<template>
  <div class="footer">
    <div class="footerDiv">
      <div class="fhDiv">
        <div class="wrap">
          <div class="hdDiv flexbet">
            <div class="hlDiv">
              <div class="logoDiv"><img src="/images/logo.png" alt="Chenghong Technology"></div>
              <div class="shareDiv">
                <a v-if="wechatQr" href="###">
                  <span class="flexcen"><i class="font_family icon-weixin"></i></span>
                  <div class="ewmDiv"><img :src="$media(wechatQr)" alt="WeChat"></div>
                </a>
                <a v-if="douyinQr" href="###">
                  <span class="flexcen"><i class="font_family icon-douyin"></i></span>
                  <div class="ewmDiv"><img :src="$media(douyinQr)" alt="Douyin"></div>
                </a>
                <a v-if="shipinhaoQr" href="###">
                  <span class="flexcen"><i class="font_family icon-shipinhao"></i></span>
                  <div class="ewmDiv"><img :src="$media(shipinhaoQr)" alt="Channels"></div>
                </a>
              </div>
              <div class="emailDiv">
                <p>{{ $t('footer.email') }}{{ $t('colon') }}</p>
                <p><a :href="'mailto:' + email">{{ email }}</a></p>
              </div>
            </div>
            <div class="hrDiv flexbet">
              <div class="listDiv" :class="{ 'listDiv--wide': shouldSplitNav(productNav) }">
                <span><router-link to="/product/">{{ $t('nav.products') }}</router-link></span>
                <div class="aDiv" :class="{ flexsta: shouldSplitNav(productNav) }">
                  <router-link v-for="item in productNav" :key="item.slug" :to="'/product/' + item.slug + '/'">{{ navItemLabel(item, 'productNav') }}</router-link>
                </div>
              </div>
              <div class="listDiv" :class="{ 'listDiv--wide': shouldSplitNav(applicationNav) }">
                <span><router-link to="/case/">{{ $t('nav.applications') }}</router-link></span>
                <div class="aDiv" :class="{ flexsta: shouldSplitNav(applicationNav) }">
                  <router-link v-for="item in applicationNav" :key="item.slug" :to="'/case/' + item.slug + '/'">{{ navItemLabel(item, 'applicationNav') }}</router-link>
                </div>
              </div>
              <div class="listDiv" :class="{ 'listDiv--wide': shouldSplitNav(newsNav) }">
                <span><router-link to="/news/">{{ $t('nav.news') }}</router-link></span>
                <div class="aDiv" :class="{ flexsta: shouldSplitNav(newsNav) }">
                  <router-link v-for="item in newsNav" :key="item.slug" :to="'/news/' + item.slug + '/'">{{ navItemLabel(item, 'newsNav') }}</router-link>
                </div>
              </div>
              <div class="listDiv" :class="{ 'listDiv--wide': shouldSplitNav(serviceNav) }">
                <span><router-link to="/service/">{{ $t('nav.services') }}</router-link></span>
                <div class="aDiv" :class="{ flexsta: shouldSplitNav(serviceNav) }">
                  <router-link v-for="item in serviceNav" :key="item.slug" :to="'/service/' + item.slug + '/'">{{ item.name || navItemLabel(item, 'serviceNav') }}</router-link>
                </div>
              </div>
              <div class="listDiv" :class="{ 'listDiv--wide': shouldSplitNav(aboutNav) }">
                <span><router-link to="/about/">{{ $t('nav.about') }}</router-link></span>
                <div class="aDiv" :class="{ flexsta: shouldSplitNav(aboutNav) }">
                  <router-link v-for="item in aboutNav" :key="item.slug" :to="aboutLink(item)">{{ navItemLabel(item, 'aboutNav') }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="bdDiv">
            <ul class="flexbet">
              <li>
                <span>{{ $t('footer.hotline') }}{{ $t('colon') }}</span>
                <p class="f18 flexsta"><a :href="'tel:' + phone">{{ phone }}</a></p>
              </li>
              <li>
                <span>{{ $t('footer.headquarters') }}{{ $t('colon') }}</span>
                <p>{{ hqAddress }}</p>
              </li>
              <li>
                <span>{{ $t('footer.factory') }}{{ $t('colon') }}</span>
                <p>{{ factoryAddress }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="fbDiv">
        <div class="wrap">
          <div class="banquan">
            &copy; {{ year }} {{ companyName }}&nbsp;&nbsp;
            <a v-if="icpText" :href="icpUrl" target="_blank" rel="noopener">{{ icpText }}</a>&nbsp;&nbsp;&nbsp;&nbsp;
            <a v-if="psbText" class="psb-link" :href="psbHref" rel="noreferrer" target="_blank">
              <img class="psb-link__icon" src="/images/gongan.png" alt="" width="16" height="16">
              <span>{{ psbText }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listContactInfo } from '@/utils/http'
import { unwrapRows } from '@/utils/content'
import { fetchSiteNav, resetSiteNavCache, getInitialSiteNav } from '@/utils/siteNav'
import { getDefaultLocale } from '@/i18n'

export default {
  name: 'HiraysFooter',
  data() {
    const initialNav = getInitialSiteNav(getDefaultLocale())
    return {
      wechatQr: '',
      douyinQr: '',
      shipinhaoQr: '',
      productNav: initialNav.productNav,
      applicationNav: initialNav.applicationNav,
      newsNav: initialNav.newsNav,
      serviceNav: initialNav.serviceNav,
      aboutNav: initialNav.aboutNav,
      email: '',
      phone: '',
      hqAddress: '',
      factoryAddress: '',
      companyName: '',
      icpText: '',
      icpUrl: 'https://beian.miit.gov.cn/',
      psbText: '',
      psbUrl: 'https://beian.mps.gov.cn/#/query/webSearch',
      year: new Date().getFullYear()
    }
  },
  created() {
    this.loadFooter()
  },
  computed: {
    /** Official MPS query URL with filing code when available */
    psbHref() {
      const codeMatch = String(this.psbText || '').match(/(\d{10,})/)
      if (codeMatch) {
        return 'https://beian.mps.gov.cn/#/query/webSearch?code=' + codeMatch[1]
      }
      return this.psbUrl || 'https://beian.mps.gov.cn/#/query/webSearch'
    }
  },
  methods: {
    reloadCmsData() {
      resetSiteNavCache()
      this.loadFooter()
    },
    applyNav(nav) {
      if (!nav) return
      this.productNav = nav.productNav
      this.applicationNav = nav.applicationNav
      this.newsNav = nav.newsNav
      this.serviceNav = nav.serviceNav
      this.aboutNav = nav.aboutNav
    },

    navItemLabel(item, group) {
      return this.$navItemLabel(group, item)
    },
    /** >6 links → second column (footer height stays ~6 rows) */
    shouldSplitNav(list) {
      return Array.isArray(list) && list.length > 6
    },
    aboutLink(item) {
      const hash = item.hash || 'page11'
      return { path: '/about/', hash: '#' + hash }
    },
    async loadFooter() {
      this.applyFooterFallback()
      try {
        const [contactRes, nav] = await Promise.all([
          listContactInfo({ type: 0, status: 1, pageNum: 1, pageSize: 1 }, this.$i18n.locale),
          fetchSiteNav(false, this.$i18n.locale)
        ])
        if (nav) this.applyNav(nav)
        this.applyContactInfo(unwrapRows(contactRes)[0])
      } catch (e) { /* fallback */ }
    },
    applyContactInfo(contact) {
      if (!contact) return
      // CMS 有记录时以后台为准：清空 = 不显示，不再回退到旧海瑞思备案文案
      this.email = contact.email || ''
      this.phone = contact.phone || ''
      this.hqAddress = contact.address ? this.$cleanBrand(contact.address) : ''
      const factory = contact.factoryAddress || contact.factory_address
      this.factoryAddress = factory ? this.$cleanBrand(factory) : ''
      this.wechatQr = contact.wechatQr || ''
      this.douyinQr = contact.douyinQr || ''
      this.shipinhaoQr = contact.shipinhaoQr || ''
      const title = contact.companyTitle || contact.company_title
      this.companyName = title ? this.$cleanBrand(title) : this.$t('footer.companyName')
      this.icpText = String((contact.icpText != null ? contact.icpText : contact.icp_text) || '').trim()
      this.icpUrl = contact.icpUrl || contact.icp_url || 'https://beian.miit.gov.cn/'
      this.psbText = String((contact.psbText != null ? contact.psbText : contact.psb_text) || '').trim()
      this.psbUrl = contact.psbUrl || contact.psb_url || 'https://beian.mps.gov.cn/#/query/webSearch'
    },
    applyFooterFallback() {
      // 仅在尚无 CMS 联系信息时使用；备案号默认留空，避免露出旧海瑞思号
      this.companyName = this.$t('footer.companyName')
      this.icpText = ''
      this.psbText = ''
      this.icpUrl = 'https://beian.miit.gov.cn/'
      this.psbUrl = 'https://beian.mps.gov.cn/#/query/webSearch'
    }
  }
}
</script>
